import Vue from 'vue';
export const EventBus = new Vue();

export enum Key {
  ChangeFeedTab = 'changeFeedTab',
  DeleteRace = 'deleteRace',
  HideOverlay = 'hideOverlay',
  ShowImportedActivity = 'showImportedActivity',
  ShowOverlay = 'showOverlay',
  ShowTrainingPlanItem = 'showTrainingPlanItem',
  ShowChangeMembership = 'showChangeMembership',
  ShowDowngradePlan = 'showDowngradePlan',
};
